import ImageWithLightboxPresentation from 'components/ImageWithLightbox/ImageWithLightboxPresentation'

export default {
  Presentation: ImageWithLightboxPresentation,
}
